















































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  PaymentType,
  SelectedPaymentMethod
} from "@/models/selectPaymentMethod";
import { IBrand } from "@/models/brands";
import { UUID } from "@/data/enums";
import { ICurrency } from "@/models/constants";

@Component({
  components: {
    "manual-payment": () =>
      import("@/components/app/global/payments/paymentType/manualPayment.vue"),
    "partial-payment": () =>
      import("@/components/app/global/payments/paymentType/partialPayment.vue"),
    "pay-later": () =>
      import("@/components/app/global/payments/paymentType/payLater.vue")
  }
})
export default class PaymentTypeComponent extends Vue {
  @Prop({ default: "" })
  public currencyId!: ICurrency["id"];

  @Prop({ default: UUID.ORG })
  public brandId!: IBrand["id"];

  @Prop({ default: 0 })
  public value!: number;

  @Prop({ default: false })
  public hasPayLater!: boolean;

  @Prop({ default: false })
  public hasManualPayment!: boolean;

  @Prop({ default: false })
  public hasPartialPayment!: boolean;

  @Prop({ default: false })
  public canChangeManualPaymentAmount!: boolean;

  @Prop({ default: true })
  public showManualAmountInput!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  public paymentType: PaymentType = PaymentType.PAY_IN_FULL;
  public paymentTypes = PaymentType;

  public get totalAmount() {
    return this.value;
  }

  public set totalAmount(value) {
    this.$emit("input", value);
  }

  public selectPaymentMethod(
    selectedPaymentMethod: SelectedPaymentMethod | null
  ) {
    this.$emit("selected-payment-method", selectedPaymentMethod);
  }
}
